export default function BlockStack({
    children,
    gap,
    flushMargins,
    itemsCenter,
    itemsStart,
    itemsEnd,
    spaceBetween,
}) {
    let finalClassName = 'block-stack'
    if (gap) finalClassName += ` gap-${gap}`
    if (itemsCenter) finalClassName += ' items-center'
    if (itemsStart) finalClassName += ' items-start'
    if (itemsEnd) finalClassName += ' items-end'
    if (spaceBetween) finalClassName += ' space-between'
    if (flushMargins) finalClassName += ' flush-margins'
    return <div className={finalClassName}>{children}</div>
}
